import * as yup from 'yup'

import allowedValues from './allowed.values.js'

import {
  requiredString,
  stringNullable,
  requiredNumber,
  requiredBool,
  state,
  string
} from '../yup/schemas.js'

import { VALIDATION, NOTIFICATION_ABOUT_NEW_BOARD } from '../constants.js'

export const companySchema = yup.object({
  id: requiredString.uuid(),
  name: requiredString,
  url: stringNullable.addProtocol().customUrl(VALIDATION.MESSAGES.URL),
  dot: requiredString
    .matches(VALIDATION.REGEXP.ONLY_DIGITS, VALIDATION.MESSAGES.NUMBER),
  addressHQ: yup.object({
    street: requiredString,
    city: requiredString,
    state: state.required(),
    zip: requiredString.zip()
  }).objectRequired(),
  locationQuantity: requiredString.oneOf(allowedValues.locationQuantity),
  employeesQuantity: requiredString.oneOf(allowedValues.employeesQuantity),
  CDLDriversQuantity: requiredString.oneOf(allowedValues.CDLDriversQuantity),
  formalTrainingProcess: requiredBool,

  hireWithExperience: requiredBool,
  minimumDUITime: requiredNumber.existsWhen('hireWithExperience', true),
  maximumDUIInLife: requiredNumber.existsWhen('hireWithExperience', true),

  hireWithFelonies: requiredBool,

  makeOfTractors: yup.array().of(yup.string().oneOf(allowedValues.makeOfTractors)).notEmpty().required(),

  union: requiredBool,

  healthInsurance: requiredBool,
  healthInsuranceForEmployee: requiredString.oneOf(allowedValues.healthInsuranceForEmployee).existsWhen('healthInsurance', true),
  healthInsuranceForFamily: requiredString.oneOf(allowedValues.healthInsuranceForFamily).existsWhen('healthInsurance', true),
  healthInsuranceEligableAfter: requiredNumber.existsWhen('healthInsurance', true),

  dentalInsurance: requiredBool,
  dentalInsuranceForEmployee: requiredString.oneOf(allowedValues.dentalInsuranceForEmployee).existsWhen('dentalInsurance', true),
  dentalInsuranceForFamily: requiredString.oneOf(allowedValues.dentalInsuranceForFamily).existsWhen('dentalInsurance', true),
  dentalInsuranceEligableAfter: requiredNumber.existsWhen('dentalInsurance', true),

  visionInsurance: requiredBool,
  visionInsuranceForEmployee: requiredString.oneOf(allowedValues.visionInsuranceForEmployee).existsWhen('visionInsurance', true),
  visionInsuranceForFamily: requiredString.oneOf(allowedValues.visionInsuranceForFamily).existsWhen('visionInsurance', true),
  visionInsuranceEligableAfter: requiredNumber.existsWhen('visionInsurance', true),

  retirementPlan: requiredBool,

  paidHolidays: requiredBool,
  numberOfPaidHolidays: requiredNumber.min(1, VALIDATION.MESSAGES.MIN(1)).max(20, VALIDATION.MESSAGES.MAX(20)).existsWhen('paidHolidays', true),

  paidVacation: requiredBool,
  vacation: yup.array().of(
    yup.object({
      bottomExperience: requiredNumber,
      topExperience: requiredNumber,
      vacationDays: requiredNumber
    }).objectRequired()
  )
    .notEmpty()
    .existsWhen('paidVacation', true)
    .required(),

  bonuses: requiredBool,
  bonusesTypes: yup.array().of(yup.string().oneOf(allowedValues.bonusesTypes))
    .notEmpty()
    .existsWhen('bonuses', true)
    .required(),

  passengersAllowed: requiredBool,
  passengersTypes: yup.array().of(yup.string().oneOf(allowedValues.passengersTypes))
    .notEmpty()
    .existsWhen('passengersAllowed', true)
    .required(),

  petsAllowed: requiredBool,
  petsTypes: yup.array().of(yup.string().oneOf(allowedValues.petsTypes))
    .notEmpty()
    .existsWhen('petsAllowed', true)
    .required(),

  useOurWebsiteApplicationForm: yup.boolean(),
  notificationAboutNewBoard: string.oneOf(Object.values(NOTIFICATION_ABOUT_NEW_BOARD)),
  applicationLink: requiredString.addProtocol().url(VALIDATION.MESSAGES.URL)
    .existsWhen('useOurWebsiteApplicationForm', false)
}).objectRequired()
